import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from "@environments/environment";
import { HttpClient } from '@angular/common/http';
declare var $: any; // TODO show modal in othe way


// Translate
import { TranslateService } from '@ngx-translate/core';

// Services
import {
  ResourceService,
  UserService,
  CalendarLanguagueService
} from "@services/index.service";

// Interfaces
import { DatabaseResourcesService } from '@services/database-resources/database-resources.service';
import { BookappointmentsBase } from '@pages/bookappointments/bookappointments.base';
import { ResponseDataBase } from '@interfaces/responsedatabase.interface';
import { AppConstants } from '@app/appConstants';

/** Página de entrada a la aplicación */
@Component({
  selector: 'app-bookappointments',
  templateUrl: './bookappointments.page.html',
  styleUrls: ['./bookappointments.page.scss'],
  animations: environment.ANIMATIONS
})
export class BookappointmentsComponent extends BookappointmentsBase {

  constructor(public router: Router,
    public _resourceService: ResourceService,
    public translate: TranslateService,
    public _userService: UserService,
    public http: HttpClient,
    public _databaseResourcesService: DatabaseResourcesService,
    public locale: CalendarLanguagueService) {
    super(router, _resourceService, translate, _userService, http, _databaseResourcesService, locale);
  }

  bookSlot(selectedFreeslot) {
    console.log('Estamos en HASIS', selectedFreeslot);
    if (selectedFreeslot.payorName) {
      delete selectedFreeslot.payorName;
    }
    if (this.isForDependents) {
      if (!this.dependentId) {
        this.alert = "PLEASE_SELECT_DEPENDENT";
        $('#FreeSlotModal').animate({ scrollTop: 0 }, 'slow');
      } else {
        delete this.alert;
        $('#FreeSlotModal').modal('hide');
        this.bookDependentSlot(selectedFreeslot);
      }
    } else {
      $('#FreeSlotModal').modal('hide');
      this.bookPatientSlot(selectedFreeslot);
    }

  }

  /** Función que reserva un slot para el usuario. El back necesita un VisitType y como esta versión no lo incluye en todos sus 
   * formatos, de momento lo hardcodeamos. Luego mandamos los datos al back y si la respuesta es correcta vamos directamente al 
   * listado de citas del usuario. Si se ha creado un ppid pedimos los datos del usuario  (función que ya nos lleva al listado)
   *  y si ha dado error lo mostramos.
   */
  bookPatientSlot(selectedFreeslot) {
    window.scrollTo(0, 0);
    let params = {
      visitType: { id: "1", name: "First appointment", departmentId: "*", treatmentId: "*" },
      slot: selectedFreeslot,
      payorId: this.searchterms.payorId,
      patient: {
        patnr: this._userService.user.patnr,
        papid: this._userService.user.papid,
        email: this._userService.user.email,
      },
    };
    this._userService.doActionPatient('confirmappointment', params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS === AppConstants.STATUS.OK) {
        this.router.navigate(['/user/myappointments']);
      } else if (response.METADATA.STATUS === AppConstants.STATUS.PAPID_CREATED) {
        this._userService.getData('');
      } else {
        // TODO que el back devuelva la clave en lugar de la string
        if (response.METADATA.ERROR_MESSAGE == 'You can have up to 2 appointments in the future.') {
          this._resourceService.alert = 'NO_MORE_TWO_APPOINTMENTS';
        } else {
          this._resourceService.manageErrorMessage(response.METADATA.ERROR_MESSAGE);
        }
        this._userService.loading = false;
      }
    }, err => {
      this._userService.checkError(err);
    });
    delete this._resourceService.selectedFreeslot;
  }

  /** Función que reserva un slot para un usuario dependiente del usuario. El back necesita un VisitType y como esta versión no lo incluye en todos sus
   * formatos, de momento lo hardcodeamos. Luego mandamos los datos al back y si la respuesta es correcta vamos directamente al
   * listado de citas del usuario. Si se ha creado un ppid pedimos los datos del usuario (función que ya nos lleva al listado)
   *  y si ha dado error lo mostramos.
   */
  bookDependentSlot(selectedFreeslot) {
    window.scrollTo(0, 0);
    let dependentId = this.dependentId
    let dependent = this._userService.user.dependents.filter(function (dependent) {
      return dependent.id === dependentId;
    })[0];

    let params = {
      visitType: { id: "1", name: "First appointment", departmentId: "*", treatmentId: "*" },
      slot: selectedFreeslot,
      payorId: this.searchterms.payorId,
      patient: {
        patnr: dependent.patnr,
        papid: dependent.papid,
        dependentId: dependent.id
      },
    };
    this._userService.doActionPatient('confirmappointment', params).subscribe(data => {
      let response = data as ResponseDataBase;
      if (response.METADATA.STATUS === AppConstants.STATUS.OK) {
        this.router.navigate(['/user/myappointments']);
      } else if (response.METADATA.STATUS === AppConstants.STATUS.PAPID_CREATED) {
        let params = {
          dependentId: dependent.id
        }
        this._userService.getData(params);
      } else {
        this._resourceService.manageErrorMessage(response.METADATA.ERROR_MESSAGE);
      }
    });
    delete this._resourceService.selectedFreeslot;
  }

}
